import { render } from "./MenuTitle.vue?vue&type=template&id=c77ce234&scoped=true"
import script from "./MenuTitle.vue?vue&type=script&lang=js"
export * from "./MenuTitle.vue?vue&type=script&lang=js"

import "./MenuTitle.vue?vue&type=style&index=0&id=c77ce234&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c77ce234"]])

export default __exports__